"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminDashboardProjects = void 0;
const React = __importStar(require("react"));
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const antd_1 = require("antd");
const AdminMGTProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/admin/AdminMGTProvider");
const lodash_1 = __importDefault(require("lodash"));
const AdminDashboardProjects = () => {
    var _a, _b, _c, _d, _e;
    const adminMGTContext = (0, AdminMGTProvider_1.useAdminMGTContext)();
    const inProgress = adminMGTContext.status.inProgress;
    const information = (_a = adminMGTContext.data) === null || _a === void 0 ? void 0 : _a.information;
    const projectUsersStore1 = lodash_1.default.mapKeys((_b = information === null || information === void 0 ? void 0 : information.analyticsStore) === null || _b === void 0 ? void 0 : _b.projectUsers, v => v[0]);
    const projectUsersStore2 = lodash_1.default.mapKeys((_c = information === null || information === void 0 ? void 0 : information.analyticsStore2) === null || _c === void 0 ? void 0 : _c.projectUsers, v => v[0]);
    const pairs = lodash_1.default.compact(lodash_1.default.map((_e = (_d = information === null || information === void 0 ? void 0 : information.management) === null || _d === void 0 ? void 0 : _d.projects) === null || _e === void 0 ? void 0 : _e.split("||"), pair => {
        const array = pair.split("|");
        return lodash_1.default.compact(array);
    }));
    const dataSource = lodash_1.default.sortBy(lodash_1.default.map(pairs, pair => {
        const usersForProjectStore1 = projectUsersStore1[pair[0]];
        const usersForProjectStore2 = projectUsersStore2[pair[0]];
        const numberOfUsersStore1 = lodash_1.default.size(usersForProjectStore1) === 2 ? Number(lodash_1.default.replace(usersForProjectStore1[1], "_", "")) : 0;
        const numberOfUsersStore2 = lodash_1.default.size(usersForProjectStore2) === 2 ? Number(lodash_1.default.replace(usersForProjectStore2[1], "_", "")) : 0;
        return {
            projectId: Number(pair[0]),
            name: pair[1] || "-",
            numberOfUsers: numberOfUsersStore1 + numberOfUsersStore2,
            numberOfUsersStore1: numberOfUsersStore1,
            numberOfUsersStore2: numberOfUsersStore2,
        };
    }), v => -v.numberOfUsers);
    if (!!process.env.IS_TEST_SERVER) {
        console.log("AdminDashboardProjects: projectUsersStore1", projectUsersStore1);
        console.log("AdminDashboardProjects: projectUsersStore2", projectUsersStore2);
        console.log("AdminDashboardProjects: pairs", pairs);
        console.log("AdminDashboardProjects: dataSource", dataSource);
    }
    return React.createElement(React.Fragment, null,
        React.createElement(PageContent_1.default.CardSpacer, null),
        React.createElement(PageContent_1.default.Card, null,
            React.createElement(antd_1.Table, { rowKey: record => `${record.projectId}`, dataSource: dataSource, loading: inProgress, pagination: { hideOnSinglePage: false, defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ["10", "50", "100", "300"], showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items` } },
                React.createElement(antd_1.Table.Column, { key: "projectId", dataIndex: "projectId", title: "Id", sorter: (a, b) => a.projectId - b.projectId }),
                React.createElement(antd_1.Table.Column, { key: "name", dataIndex: "name", title: "Name", sorter: (a, b) => a.name.localeCompare(b.name) }),
                React.createElement(antd_1.Table.Column, { key: "numberOfUsers", dataIndex: "numberOfUsers", title: "Users", sorter: (a, b) => a.numberOfUsers - b.numberOfUsers }),
                React.createElement(antd_1.Table.Column, { key: "numberOfUsersStore1", dataIndex: "numberOfUsersStore1", title: "Users in analyticsStore", sorter: (a, b) => a.numberOfUsersStore1 - b.numberOfUsersStore1 }),
                React.createElement(antd_1.Table.Column, { key: "numberOfUsersStore2", dataIndex: "numberOfUsersStore2", title: "Users in analyticsStore2", sorter: (a, b) => a.numberOfUsersStore2 - b.numberOfUsersStore2 }))));
};
exports.AdminDashboardProjects = AdminDashboardProjects;
